/* istanbul ignore file */
import isProd from 'isProd';
import isDemoEnv from 'isDemoEnv';

export enum Features {
  GROUP_ASSIGNMENTS = 'groupAssignments',
  EMPLOYEE_OFFERS = 'employeeOffers',
  ASSIGNMENT_SIDEBAR = 'assignmentSideBar',
  SYSTEMS_HEALTH = 'systemsHealth',
  NEW_RECRUITING_DASHBOARD = 'NEW_RECRUITING_DASHBOARD',
  NEW_PROJECT_CHANGE_REQUEST = 'NEW_PROJECT_CHANGE_REQUEST',
  NEW_PROJECT_WASTE = 'NEW_PROJECT_WASTE',
  NEW_PROJECT_EVM = 'NEW_PROJECT_EVM',
  NEW_PROJECT_CUSTOMER_REPORT = 'NEW_PROJECT_CUSTOMER_REPORT',
  NEW_PROJECT_SDLC = 'NEW_PROJECT_SDLC',
  NEW_PROJECT_DASHBOARD = 'NEW_PROJECT_DASHBOARD',
  ASSIGNMENT_TEAM_MEMBERSHIP = 'ASSIGNMENT_TEAM_MEMBERSHIP',
  PROJECT_TEAM_TAB = 'PROJECT_TEAM_TAB',
  PROJECT_POLICIES_TEAM = 'PROJECT_POLICIES_TEAM',
  PROJECT_CRITICAL_PERIODS_TEAM = 'PROJECT_CRITICAL_PERIODS_TEAM',
  PROJECT_UPCOMING_CHANGES_TEAM = 'UPCOMING_CHANGES_TEAM',
  PROJECT_PLANNED_LEAVES_TEAM = 'PROJECT_PLANNED_LEAVES_TEAM',
  STAFFING_ASSIGNMENTS = 'STAFFING_ASSIGNMENTS',
  STAFFING_DASHBOARD = 'STAFFING_DASHBOARD',
  STAFFING_NOTES = 'STAFFING_NOTES',
  PURCHASE_REQUEST_PURCHASE_INVOICE = 'PURCHASE_REQUEST_PURCHASE_INVOICE',
  CREATE_PROJECT = 'CREATE_PROJECT',
  UPDATE_PROJECT = 'UPDATE_PROJECT',
  OPERATIONAL_ASSETS = 'OPERATIONAL_ASSETS',
  STAFFING_CHARTS = 'STAFFING_CHARTS',
  EXPERTISE = 'EXPERTISE',
  NEW_PROJECT_BILLING = 'NEW_PROJECT_BILLING',
  STAFFING_HEATMAP = 'STAFFING_HEATMAP',
  NEW_PROJECT_ACCEPTANCE = 'NEW_PROJECT_ACCEPTANCE',
  NEW_PROJECT_ASSUMPTIONS = 'NEW_PROJECT_ASSUMPTIONS',
  NEW_PROJECT_TIMELINE = 'NEW_PROJECT_TIMELINE',
  ACCOUNT_TICKET_RETENTION_ON_HOLD = 'ACCOUNT_TICKET_RETENTION_ON_HOLD',
  NEW_PROJECT_STAKEHOLDERS = 'NEW_PROJECT_STAKEHOLDERS',
  CONTROLS = 'CONTROLS',
  EMPLOYEE_PORTAL_COMPLIANCE = 'EMPLOYEE_PORTAL_COMPLIANCE',
  COMPLIANCE_NOTIFICATIONS = 'COMPLIANCE_NOTIFICATIONS',
  NEW_PROJECT_ENGINEERING = 'NEW_PROJECT_ENGINEERING',
  NEW_PROJECT_REUSE_DATA = 'NEW_PROJECT_REUSE_DATA',
  OPPORTUNITY_SERVICE_UPDATE = 'OPPORTUNITY_SERVICE_UPDATE',
  OPPORTUNITY_DASHBOARD = 'OPPORTUNITY_DASHBOARD',
  POSITION_SLOTS = 'POSITION_SLOTS',
  POSITION_PROFILES = 'POSITION_PROFILES',
  POSITION_SLOTS_COLLECTION_PREVIEW = 'POSITION_SLOTS_COLLECTION_PREVIEW',
  POSITION_FILL_REQUESTS_COLLECTION = 'POSITION_FILL_REQUESTS_COLLECTION',
  RECRUITMENT_POOL = 'RECRUITMENT_POOL',
  HIRING_REQUEST_POSITION_SLOTS = 'HIRING_REQUEST_POSITION_SLOTS',
  NEW_PROJECT_REVIEW = 'NEW_PROJECT_REVIEW',
  CLIENT_PORTAL = 'CLIENT_PORTAL',
  INTERRUPTIONS = 'INTERRUPTIONS',
  SYBERRY_TODAY = 'SYBERRY_TODAY',
  WORKFORCE_ANALYTICS = 'WORKFORCE_ANALYTICS',
  PROJECTS_COMPLIANCE = 'PROJECTS_COMPLIANCE',
  CANDIDATES_APPLICATIONS = 'CANDIDATES_APPLICATIONS',
  TASK_MANAGEMENT_ITS07 = 'TASK_MANAGEMENT_ITS07',
  TASK_CONSTRUCTOR = 'TASK_CONSTRUCTOR',
  BUISNESS_FUNCTIONS = 'BUISNESS_FUNCTIONS',
  NEW_RECRUITING_TABS = 'NEW_RECRUITING_TABS',
}

export const featureToggles: Dictionary<boolean> = {
  [Features.GROUP_ASSIGNMENTS]: false,
  [Features.EMPLOYEE_OFFERS]: false,
  [Features.ASSIGNMENT_SIDEBAR]: !isDemoEnv(),
  [Features.SYSTEMS_HEALTH]: Boolean(isProd()),
  [Features.NEW_RECRUITING_DASHBOARD]: true,
  [Features.NEW_PROJECT_CHANGE_REQUEST]: true,
  [Features.NEW_PROJECT_EVM]: true,
  [Features.NEW_PROJECT_CUSTOMER_REPORT]: true,
  [Features.NEW_PROJECT_WASTE]: true,
  [Features.NEW_PROJECT_DASHBOARD]: true,
  [Features.ASSIGNMENT_TEAM_MEMBERSHIP]: true,
  [Features.PROJECT_TEAM_TAB]: true,
  [Features.PROJECT_POLICIES_TEAM]: true,
  [Features.NEW_PROJECT_SDLC]: true,
  [Features.PROJECT_CRITICAL_PERIODS_TEAM]: true,
  [Features.PROJECT_UPCOMING_CHANGES_TEAM]: true,
  [Features.PROJECT_PLANNED_LEAVES_TEAM]: true,
  [Features.STAFFING_DASHBOARD]: true,
  [Features.PURCHASE_REQUEST_PURCHASE_INVOICE]: !isProd(),
  [Features.CREATE_PROJECT]: true,
  [Features.UPDATE_PROJECT]: true,
  [Features.OPERATIONAL_ASSETS]: true,
  [Features.STAFFING_CHARTS]: true,
  [Features.STAFFING_ASSIGNMENTS]: true,
  [Features.STAFFING_NOTES]: true,
  [Features.EXPERTISE]: true,
  [Features.NEW_PROJECT_BILLING]: true,
  [Features.STAFFING_HEATMAP]: true,
  [Features.NEW_PROJECT_ACCEPTANCE]: true,
  [Features.NEW_PROJECT_TIMELINE]: true,
  [Features.NEW_PROJECT_ASSUMPTIONS]: true,
  [Features.ACCOUNT_TICKET_RETENTION_ON_HOLD]: true,
  [Features.NEW_PROJECT_STAKEHOLDERS]: true,
  [Features.CONTROLS]: true,
  [Features.EMPLOYEE_PORTAL_COMPLIANCE]: true,
  [Features.COMPLIANCE_NOTIFICATIONS]: true,
  [Features.NEW_PROJECT_ENGINEERING]: true,
  [Features.NEW_PROJECT_REUSE_DATA]: true,
  [Features.OPPORTUNITY_SERVICE_UPDATE]: true,
  [Features.OPPORTUNITY_DASHBOARD]: true,
  [Features.POSITION_SLOTS]: true,
  [Features.POSITION_PROFILES]: true,
  [Features.POSITION_SLOTS_COLLECTION_PREVIEW]: true,
  [Features.HIRING_REQUEST_POSITION_SLOTS]: true,
  [Features.NEW_PROJECT_REVIEW]: true,
  [Features.CLIENT_PORTAL]: true,
  [Features.INTERRUPTIONS]: !isProd(),
  [Features.SYBERRY_TODAY]: !isProd(),
  [Features.WORKFORCE_ANALYTICS]: true,
  [Features.PROJECTS_COMPLIANCE]: true,
  [Features.POSITION_FILL_REQUESTS_COLLECTION]: !isProd(),
  [Features.RECRUITMENT_POOL]: !isProd(),
  [Features.TASK_CONSTRUCTOR]: !isProd(),
  [Features.CANDIDATES_APPLICATIONS]: !isProd(),
  [Features.TASK_MANAGEMENT_ITS07]: true,
  [Features.BUISNESS_FUNCTIONS]: !isProd(),
  [Features.NEW_RECRUITING_TABS]: !isProd(),
};
